<ng-container *ngIf="product">
  <article class="product sidebar" [class.single]="!product.has_extras"
    [ngClass]="{'modeone': isModeOne, 'modetwo': isModeTwo}">
    <ng-container *ngIf="product.has_extras; then QueryLayout else SingleProductLayout"></ng-container>
    <ng-template #QueryLayout>
      <header>
        <div *ngIf="product.has_image" class="img extra">
          <img [src]="product.image_path" class="ya_image">
        </div>
        <div *ngIf="!product.has_image" class="noimg">
          <h3>{{product.label}}</h3>
        </div>
        <div class="content">
          <div class="top">
            <h2>{{product.label}}</h2>
            <p [truncatedText]="product.details.description"></p>
          </div>
          <ng-container *ngIf="use_eCommerce && product.details.hasContentLevel">
            <div class="product-content">
              <ng-container *ngIf="product.details.alcohol_Content > 0">
                <div class="product-content_level">
                  <span langkey="details_alcohol"></span>
                  <span class="info-value">{{product_alcoholContent + " %Vol."}} </span>
                </div>
              </ng-container>
              <ng-container *ngIf="product.details.caffeine_Content > 0">
                <div class="product-content_level">
                  <span langkey="details_caffeine"></span>
                  <span class="info-value">{{product_caffeineContent + " mg"}}</span>
                </div>
              </ng-container>
            </div>
          </ng-container>
          <ng-container *ngIf="(use_eCommerce && hasBaseUnit)||product.has_deposit">
            <div class="product-content_info">
              <ng-container *ngIf="hasBaseUnit">
                <div class="product-baseUnit">
                  <span *ngIf="itemBaseUnit === baseUnit.PIECE">{{pricePerUnit + " /1"}} <span
                      langkey="details_baseunit_piece"></span></span>
                  <span *ngIf="itemBaseUnit === baseUnit.LITER">{{pricePerUnit + " /1"}} <span
                      langkey="details_baseunit_liter"></span></span>
                  <span *ngIf="itemBaseUnit === baseUnit.KILO">{{pricePerUnit + " /1"}}<span
                      langkey="details_baseunit_kilo"></span></span>
                </div>
              </ng-container>
              <ng-container *ngIf="product.has_deposit">
                <div class="product-deposit">
                  <span [langkey]="deposit_langkey"></span>
                  <span class="info-value">{{product.deposit | price:"p c" }} </span>
                </div>
              </ng-container>
            </div>
          </ng-container>
          <div *ngIf="product.details.prepackaged">
            <span langkey="details_prepackaged"></span>
          </div>

          <footer>
            <!-- product filter tag icons-->
            <ng-container *ngIf="isItemTagEnabled">
              <div class="product-tag">
                <div class="tag" *ngFor="let tag of SOTProductTagViewModel" id=" productTag{{tag.id}}">
                  <div class="tag-svg" [innerHTML]="tag.svg_html"></div>
                </div>
              </div>
            </ng-container>
            <a class="btn" (click)="showProductInfo(product)" langkey="details_info"></a>
          </footer>
        </div>
      </header>

      <div class="content">
        <div class="process" [class.hideSteps]="extraGroups.length <= 1">
          <mat-horizontal-stepper #stepper>
            <ng-template matStepperIcon="edit" let-index="index">
              {{index + 1}} <!-- Completed && editiable && Not Selected Step;  -->
            </ng-template>
            <ng-template matStepperIcon="done" let-index="index">
              {{index + 1}} <!-- Completed && editable && Not Selected;  -->
            </ng-template>
            <ng-template matStepperIcon="number" let-index="index">
              {{index + 1}}<!-- Selected || Not Completed;  -->
            </ng-template>
            <ng-container *ngFor="let extraGroup of visibleExtragroups; let first = first; let last = last">
              <mat-step [optional]="!extraGroup.force_mode" [completed]="areExtraGroupRequirementsMet(extraGroup)">
                <!-- Optional muss variable sein -->
                <div class="headline">
                  <h1>{{extraGroup.title}}</h1>
                  <p class="required" [class.obligation]="highlight_required">
                    <span><span [langkey]="extraGroup.force_mode ? 'details_obligation' : 'details_selection'"></span>:
                    </span>{{getCount(extraGroup)}}/{{extraGroup.max_choices}}
                  </p>
                </div>
                <sot-scroller-vertical>
                  <div class="articles" [class.small]="extraGroup.extra_items.length > 5">
                    <ng-container *ngFor="let extra of extraGroup.extra_items">
                      <ng-container
                        *ngIf="extra.without_subitem; then SingleExtraTemplate else SubExtraTemplate"></ng-container>
                      <ng-template #SingleExtraTemplate>
                        <div class="dish"
                          (click)="fadeOutExtraBySelectedTag(extra)?openResetExtraTagFilter(extra): onDishClick($event, extraGroup, extra)"
                          [class.noimg]="!extra.product || !extra.product.has_image || !extra_as_image || isModeTwo"
                          [class.not-avail]="(!isExtraAvailable(extra) || fadeOutExtraBySelectedTag(extra))"
                          [class.active]="!fadeOutExtraBySelectedTag(extra) && isExtraSelected(extraGroup, extra)">
                          <div *ngIf="extra.product && extra.product.has_image && extra_as_image" class="img">
                            <img class="ya_image" [src]="extra.product.image_path">
                          </div>
                          <div class="content container">
                            <div class="top extra-content--top">
                              <header>
                                <h2>{{extra.title}}</h2>
                                <ng-container *ngIf="displayAdditionalInformation(extra.product)">
                                  <div class="info-content">
                                    <a class="btn"
                                      (click)="showExtraProductInfo(extra.product,extra.title,$event)"><span>i</span></a>
                                  </div>
                                </ng-container>
                              </header>
                              <ng-container *ngIf="extra.product">
                                <p [truncatedText]="extra.product.details.description"></p>
                              </ng-container>
                            </div>
                            <ng-container *ngIf="isItemTagEnabled && extra.product">
                              <div class="product-tag extra-tag">
                                <div class="tag"
                                  *ngFor="let extra_tag of GetExtraProductTagsByIds(extra.product.product_tag_ids)"
                                  id="extraProductTag{{extra_tag.id}}">
                                  <div class="tag-svg" [innerHTML]="extra_tag.svg_html"></div>
                                </div>
                              </div>
                            </ng-container>
                            <!--Extra: Base price & Deposit-->
                            <ng-container
                              *ngIf="(use_eCommerce && showBasePrice(extraGroup, extra))||extra.has_deposit">
                              <div class="product-content_info">
                                <ng-container *ngIf="showBasePrice(extraGroup, extra)">
                                  <div class="product-baseUnit">
                                    <span
                                      *ngIf="extraBaseUnit(extra.product) === baseUnit.PIECE">{{extraBasePricePerUnit(extraGroup,
                                      extra)}}<span langkey="details_baseunit_piece"></span></span>
                                    <span
                                      *ngIf="extraBaseUnit(extra.product) === baseUnit.LITER">{{extraBasePricePerUnit(extraGroup,
                                      extra)}}
                                      <span langkey="details_baseunit_liter"></span></span>
                                    <span
                                      *ngIf="extraBaseUnit(extra.product)=== baseUnit.KILO">{{extraBasePricePerUnit(extraGroup,
                                      extra)}}<span langkey="details_baseunit_kilo"></span></span>
                                  </div>
                                </ng-container>
                                <ng-container *ngIf="extra.has_deposit">
                                  <div class="extra-deposit"
                                    [class.deposit-customized]="extraGroup.extra_items.length > 5">
                                    <span [langkey]="deposit_langkey"></span>
                                    <span class="info-value">{{extra.deposit | price:"p c" }} </span>
                                  </div>
                                </ng-container>
                              </div>
                            </ng-container>
                            <footer>
                              <div class="preis">{{itemViewPrice(extraGroup, extra) | price:"+p c" }}</div>
                              <ng-container *ngIf="extraGroup.max_choices === 1">
                                <a class="btn insert"
                                  [class.active]="!fadeOutExtraBySelectedTag(extra)&& isExtraSelected(extraGroup, extra)">
                                  <div inlineSVG="sot/sot-icon.svg#sot-done" flex [setSVGAttributes]="{class: 'icon'}">
                                  </div>
                                </a>
                              </ng-container>
                              <sot-amount *ngIf="extraGroup.max_choices > 1" [amount]="getCount(extraGroup, extra)"
                                [max]="getCount(extraGroup, extra) + extraGroup.max_choices - getCount(extraGroup)"
                                (amountChange)="setExtraCountTo($event, extraGroup, extra)"
                                [class.small]="extraGroup.extra_items.length > 5"></sot-amount>
                            </footer>
                          </div>
                          <div *ngIf="!isExtraAvailable(extra)" class="not-available">
                            <ng-container
                                *ngIf="extra.product && !extra.product.schedule.active && extra.product.schedule.hint; then ScheduleHintTemplate else NotAvailableHintTemplate"></ng-container>
                              <ng-template #ScheduleHintTemplate>
                                <span>{{extra.product.schedule.hint}}</span>
                            </ng-template>
                            <ng-template #NotAvailableHintTemplate>
                              <span langkey="details_not_available"></span>
                            </ng-template>
                          </div>
                          <div *ngIf="isExtraAvailable(extra) && fadeOutExtraBySelectedTag(extra)"
                            class="not-available">
                            <span langkey="tags_article_labeling_text"></span>
                          </div>
                        </div>
                      </ng-template>
                      <ng-template #SubExtraTemplate>
                        <div class="dish"
                          (click)="fadeOutExtraBySelectedTag(extra)? openResetExtraTagFilter(extra): '';$event.stopPropagation()"
                          [class.noimg]="!extra.product || !extra.product.has_image || !extra_as_image || isModeTwo"
                          [class.not-avail]="(!isExtraAvailable(extra) || fadeOutExtraBySelectedTag(extra))"
                          [class.active]="!fadeOutExtraBySelectedTag(extra) && isExtraSelected(extraGroup, extra)">
                          <div *ngIf="extra.product && extra.product.has_image && extra_as_image" class="img">
                            <img class="ya_image" [src]="extra.product.image_path">
                          </div>
                          <div class="content container">
                            <div class="top sub-extra-content--top">
                              <header>
                                <h2>{{extra.title}}</h2>
                              </header>
                              <ng-container *ngIf="extra.product">
                                <p [truncatedText]="extra.product.details.description"></p>
                              </ng-container>
                            </div>
                            <footer class="footer-content--more">
                              <ng-container>
                                <a class="btn more-button"
                                  (click)="showProductSubDialog(product,extra, extraGroup); $event.stopPropagation()">
                                  <div>
                                    <div inlineSVG="sot/sot-icon.svg#sot-expand_more" class="expand-more">
                                    </div>
                                  </div>
                                </a></ng-container>
                            </footer>
                          </div>
                          <div
                            *ngIf="!isExtraAvailable(extra)&&(fadeOutExtraBySelectedTag(extra) || !fadeOutExtraBySelectedTag(extra)) "
                            class="not-available">
                            <span langkey="details_not_available"></span>
                          </div>
                          <div *ngIf="isExtraAvailable(extra) && fadeOutExtraBySelectedTag(extra)"
                            class="not-available">
                            <span langkey="tags_article_labeling_text"></span>
                          </div>
                        </div>
                      </ng-template>
                    </ng-container>
                  </div>
                </sot-scroller-vertical>
                <div class="scroll-bottom" *ngIf="show_product_list_bottom_scroll"
                  inlineSVG="sot/sot-icon.svg#down_arrows" [setSVGAttributes]="{class: 'arrows'}"></div>
                <footer class="buttons">
                  <ng-container *ngIf="first && isFromRecipeLinking">
                    <button mat-button class="btn goback insert" (click)="back()">
                      <div inlineSVG="sot/sot-icon.svg#sot-backward" flex [setSVGAttributes]="{class: 'btn-icon'}">
                      </div>
                      <span langkey="button_back"></span>
                    </button>
                  </ng-container>
                  <ng-container *ngIf="!first">
                    <button mat-button matStepperPrevious class="btn goback">
                      <div inlineSVG="sot/sot-icon.svg#sot-backward" flex [setSVGAttributes]="{class: 'btn-icon'}">
                      </div>
                      <span langkey="button_back"></span>
                    </button>
                  </ng-container>
                  <ng-container *ngIf="!last">
                    <button mat-button [class.disabled]="!areExtraGroupRequirementsMet(extraGroup)"
                      (click)="onNextExtraGroupClick(extraGroup)" class="btn goforward">
                      <span langkey="button_continue"></span>
                      <div inlineSVG="sot/sot-icon.svg#sot-forward" flex [setSVGAttributes]="{class: 'btn-icon'}">
                      </div>
                    </button>
                  </ng-container>
                  <ng-container *ngIf="last">
                    <button mat-button [class.disabled]="!areExtraGroupRequirementsMet(extraGroup)"
                        (click)="canAddProductToBasket() ? checkRequirementAndAddToBasket() : null"
                        class="btn goforward">
                      <span langkey="button_done"></span>
                      <div inlineSVG="sot/sot-icon.svg#sot-forward" flex [setSVGAttributes]="{class: 'btn-icon'}">
                      </div>
                    </button>
                  </ng-container>
                </footer>
              </mat-step>
            </ng-container>
          </mat-horizontal-stepper>
        </div>
      </div>
      <div class="scroll-bottom" *ngIf="show_product_list_bottom_scroll" inlineSVG="sot/sot-icon.svg#sot-down_arrows"
        [setSVGAttributes]="{class: 'arrows'}"></div>
    </ng-template>
    <ng-template #SingleProductLayout>
      <header>
        <div *ngIf="product.has_image" class="img-full">
          <img [src]="product.image_path" class="ya_image">
        </div>
        <div *ngIf="!product.has_image" class="noimg-full">
          <h3>{{product.label}}</h3>
        </div>
      </header>
      <div class="content single" #product_list>
        <header>
          <h2>{{product.label}}</h2>
        </header>
        <p *ngIf="product.details.description">{{product.details.description}}</p>
        <!--product tag icon-->
        <ng-container *ngIf="isItemTagEnabled">
          <div class="product-tag">
            <div class="tag" *ngFor="let tag of SOTProductTagViewModel" id=" productTag{{tag.id}}">
              <div class="tag-svg" [innerHTML]="tag.svg_html"></div>
            </div>
          </div>
        </ng-container>
        <!-- E-commerce info and deposit-->
        <ng-container *ngIf="use_eCommerce && product.details.hasContentLevel">
          <div class="product-content">
            <ng-container *ngIf="product.details.alcohol_Content > 0">
              <div class="product-content_level">
                <span langkey="details_alcohol"></span>
                <span class="info-value">{{product_alcoholContent + " %Vol."}} </span>
              </div>
            </ng-container>
            <ng-container *ngIf="product.details.caffeine_Content > 0">
              <div class="product-content_level">
                <span langkey="details_caffeine"></span>
                <span class="info-value">{{product_caffeineContent + " mg"}}</span>
              </div>
            </ng-container>
          </div>
        </ng-container>
        <ng-container *ngIf="(use_eCommerce && hasBaseUnit)||product.has_deposit">
          <div class="product-content_info">
            <ng-container *ngIf="hasBaseUnit">
              <div class="product-baseUnit">
                <span *ngIf="itemBaseUnit === baseUnit.PIECE">{{pricePerUnit + " /1"}} <span
                    langkey="details_baseunit_piece"></span></span>
                <span *ngIf="itemBaseUnit === baseUnit.LITER">{{pricePerUnit + " /1"}}<span
                    langkey="details_baseunit_liter"></span></span>
                <span *ngIf="itemBaseUnit === baseUnit.KILO">{{pricePerUnit + " /1"}}<span
                    langkey="details_baseunit_kilo"></span></span>
              </div>
            </ng-container>
            <ng-container *ngIf="product.has_deposit">
              <div class="product-deposit">
                <span [langkey]="deposit_langkey"></span>
                <span class="info-value">{{product.deposit | price:"p c" }} </span>
              </div>
            </ng-container>
          </div>
        </ng-container>
        <div *ngIf="product.details.prepackaged">
          <span langkey="details_prepackaged"></span>
        </div>
        <sot-properties [product]="product"></sot-properties>
      </div>
      <div class="scroll-bottom" *ngIf="show_product_list_bottom_scroll" inlineSVG="sot/sot-icon.svg#sot-down_arrows"
        [setSVGAttributes]="{class: 'arrows'}"></div>
    </ng-template>
    <aside [class.single]="!product.has_extras">
      <div class="top">
        <!--customer card-->
        <h3 langkey="main_basket"></h3>
        <div class="container warenkorb" #basket_product_list>
          <div *ngFor="let basketProduct of tempBasket.products" class="dish">
            <header>
              <h2>{{basketProduct.label}}</h2>
              <div class="preis">
                {{getBasketProductShownBasePrice(basketProduct) | price}}
              </div>
            </header>
            <div class="tempProduct">
              <ng-container *ngFor="let extragroup of basketProduct.extra_groups">
                <ng-container *ngFor="let extra of extragroup.extras">
                  <ng-container
                    *ngIf="extra.sub_extras.length === 0; then TempBasketSingleExtra else TempBasketSubExtras"></ng-container>
                  <ng-template #TempBasketSingleExtra>
                    <div class="extra">
                      <div class="title">
                        <span *ngIf="extra.count > 1">{{extra.count}}x </span>{{extra.title}}
                      </div>
                      <div class="preis" *ngIf="!extragroup.model.hasNoChoice">
                        {{getBasketExtraPrice(extra) | price:"+p c" }}
                      </div>
                    </div>
                  </ng-template>
                  <ng-template #TempBasketSubExtras>
                    <div *ngFor="let sub of extra.sub_extras" class="extra">
                      <div class="title">
                        <span *ngIf="sub.count > 1">{{sub.count}}x </span>{{extra.title}} ({{sub.title}})
                      </div>
                      <div class="preis" *ngIf="!extragroup.model.hasNoChoice">
                        {{getBasketSubExtraPrice(sub) | price:"+p c" }}
                      </div>
                    </div>
                  </ng-template>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="showDeposit(basketProduct)">
                <div class="deposit">
                  <div class="title">
                    <span langkey="details_incl_deposit"></span><!--ink. Pfand-->
                  </div>
                  <div class="preis">{{getBasketDeposit(basketProduct) | price:"+p c" }}</div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
        <div class="scroll-bottom" *ngIf="show_basket_product_list_bottom_scroll"
          inlineSVG="sot/sot-icon.svg#sot-down_arrow" [setSVGAttributes]="{class: 'arrows'}"></div>
      </div>
      <div class="bottom">
        <!--amount-->
        <div class="container amount">
          <h3 langkey="main_sum"></h3>
          <div class="price">
            <!--Anpassung ohne plus, minus-->
            <span langkey="main_sum"></span>
            <span class="preis">{{tempBasket.getTotalSumForView() | price}}</span>
          </div>
          <footer>
            <a class="btn action" [class.disabled]="!AddProductButtonStateActive()"
              (click)="AddProductButtonStateActive() ? checkRequirementAndAddToBasket() : null">
              <span langkey="button_add"></span> <!--hinzufügen-->
            </a>
            <sot-backbtn (click)="back()"></sot-backbtn>
          </footer>
        </div>
        <sot-langcall [class.single]="!product.has_extras"></sot-langcall>
      </div>
    </aside>
  </article>
</ng-container>